// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9o5Nl","bodyContent":"styles_bodyContent__bWaPq","fullWidth":"styles_fullWidth__imAXb"};